import React from "react";
import { Badge, Box, IconButton, Tooltip } from "@mui/material";
import * as Icons from "@mui/icons-material";

export const ActionIconItem = ({ item, onClick, defaulColor = "#858999", defaultIcon = "HelpOutline", height = 25, badgeContent = null }) => {
    const handleClick = () => {
        if (typeof onClick === "function") {
            onClick(item);
        }
    };

    const renderIcon = () => {
        const isImage = item.icon && (item.icon.includes(".png") || item.icon.includes(".jpg"));
        const baseColor = item.color || defaulColor;
        const hoverColor = item.iconHover || baseColor;

        let IconContent;
        if (isImage) {
            IconContent = (
                <Box
                    component="img"
                    src={item.icon}
                    alt={item.accion}
                    sx={{
                        height: height,
                        width: "auto",
                        display: "block",
                        transition: "filter 0.2s ease",
                        ".MuiIconButton-root:hover &": {
                            filter: "brightness(0.7)",
                        }
                    }}
                />
            );
        } else {
            const TargetIcon = Icons[item.icon] || Icons[defaultIcon] || Icons["Help"];
            IconContent = (
                <TargetIcon
                    sx={{ fontSize: height }}
                />
            );
        }

        return (
            <IconButton
                id={`id_${item.accion}`}
                size="small"
                onClick={handleClick}
                sx={{
                    p: 0,
                    height: height,
                    minWidth: height,
                    color: baseColor,
                    "&:hover": {
                        color: hoverColor,
                        backgroundColor: "rgba(0, 0, 0, 0.04)",
                        transition: "color 0.2s ease"
                    },
                    "& .MuiSvgIcon-root": {
                        color: "inherit"
                    }
                }}
            >
                <Badge
                    badgeContent={badgeContent}
                    color="primary"
                    overlap="circular"
                    max={999}
                    anchorOrigin={{
                        vertical: "top",
                        horizontal: "right",
                    }}
                    invisible={!item?.badge}
                >
                    {IconContent}
                </Badge>
            </IconButton>
        );
    };

    return <Tooltip title={item.accion}>
        {renderIcon()}
    </Tooltip>;
};
